import { action } from 'mobx';
import { PickingBatchService } from 'common/data';
import { BaseStore } from 'core/stores';

class PickingBatchStore extends BaseStore {
	constructor(rootStore) {
		super(new PickingBatchService(rootStore.app.baasic.apiClient));
	}

	@action
	getPickingBatch = async (id, options) => {
		const response = await this.service.get(id, options);
		this.item = response.data;
		return response.data;
	};

	@action
	async reprintLabels(id) {
		const response = await this.service.reprintLabels(id);
		this.item = response.data;
		return response.data;
	}

	@action
	async exportPickingBatch(id) {
		const response = await this.service.exportPickingBatch(id);
		this.item = response.data;
		return response.data;
	}

	@action
	async generatePdf(id) {
		const response = await this.service.generatePdf(id);
		this.response = response.data;
	}

	@action
	async resendToWms(id) {
		const response = await this.service.resendToWms(id);
		return response.data;
	}
}

export default PickingBatchStore;



// WEBPACK FOOTER //
// ./src/modules/picking-batch/stores/PickingBatchStore.js